import React, { useEffect, useState } from "react";
import { authSVC } from "../../services";
import { Form } from "antd";
import { useB2BContext } from "../../context/ContextB2B";
import CheckoutButton from "./CheckoutButton";
import AddressPopup from "./Address";

// interface props {
//   paymentOption: string;
// }
function PaymentHDFC() {
  const { getUserByID } = useB2BContext();
  const [form] = Form.useForm();
  const [paymentIsOK, setPaymentIsOK] = useState(false);
  const [paymentId, setPaymentId] = useState(false);
  const [amount, setAmount] = useState<any>("");
  const [taxAmount, setTaxAmount] = useState<any>("");
  const [amountWithOutTax, setAmountWithOutTax] = useState<any>("");
  const [taxRate, setTaxRate] = useState(18); // Default tax rate (10%)
  const [total, setTotal] = useState(0);
  const [showAddress, setShowAddress] = useState(true);
  const [companyState, setCompanyState] = useState("");
  const [paymentBreakDown, setPaymentBreakDown] = useState({
    igstTax: 0,
    cgst: 0,
    sgst: 0,
    subTotalAmount: 0,
    amountQuote: 0,
  });

  // useEffect(() => {
  //   console.log(isModalOpen, "isModalOpen");
  //   if (isModalOpen === false) {
  //     console.log(form);
  //     const formData = form.getFieldsValue();
  //     console.log(formData);
  //     sessionStorage.setItem("popupFormData", JSON.stringify(formData));

  //     // setIsVisibleAddress(true);
  //   } else {
  //     const savedData = sessionStorage.getItem("popupFormData");
  //     if (savedData) {
  //       form.setFieldsValue(JSON.parse(savedData)); // ✅ Set values before showing
  //     }
  //     // setIsVisibleAddress(false);
  //   }
  // }, [isModalOpen, form]);
  /*
  useEffect(() => {
    setAmount(getUserByID?.company_id.package[0]?.price);
    const reduction = (amount * 18) / 100; // Calculate 18% of the amount
    const finalAmount = amount - reduction; // Subtract reduction from the original amount
    setAmountWithOutTax(finalAmount.toFixed(2));
    setTaxAmount(amount - amountWithOutTax);
  }, [getUserByID, amount, taxRate, amountWithOutTax]);
*/
  // useEffect(() => {
  //   let amountBreakDown = {
  //     igstTax: 0,
  //     cgst: 0,
  //     sgst: 0,
  //     subTotalAmount: 0,
  //     amountQuote: 0,
  //   };
  //   const amountQuote = getUserByID?.company_id.package[0]?.price;
  //   amountBreakDown.igstTax = amountQuote * 0.18;
  //   amountBreakDown.cgst = amountQuote * 0.09;
  //   amountBreakDown.sgst = amountQuote * 0.09;
  //   amountBreakDown.subTotalAmount = amountQuote + amountBreakDown.igstTax;
  //   amountBreakDown.amountQuote = amountQuote;
  //   setPaymentBreakDown(amountBreakDown);
  // }, [getUserByID]);

  const packageDetails = getUserByID?.company_id?.package.map((pkg: any) => {
    const price = pkg.total_unit_employee * pkg.unit_price_per_employee;
    const taxes = price * 0.18; // IGST (18%)
    const cgst = taxes / 2; // CGST (9%)
    const sgst = taxes / 2; // SGST (9%)
    const totalAmount = price + taxes; // Total amount including taxes
    const package_duration = pkg.package_duration;

    return {
      packageName: pkg.package_id.package,
      price: price,
      IGST: taxes.toFixed(2),
      CGST: cgst.toFixed(2),
      SGST: sgst.toFixed(2),
      totalAmount: totalAmount.toFixed(2),
      package_duration: package_duration,
      emp_unit: pkg.total_unit_employee,
      unit_price: pkg.unit_price_per_employee,
    };
  });

  // Calculate Subtotal
  const subtotal = packageDetails.reduce(
    (sum: any, pkg: any) => sum + parseFloat(pkg.totalAmount),
    0
  );

  // Display Package Details and Subtotal
  console.log("Package Details:", packageDetails);
  console.log("Subtotal:", subtotal.toFixed(2));

  const HDFCPaymentInitiate = () => {
    if (getUserByID) {
      authSVC
        .initateHRMSPayment({ company_id: getUserByID.company_id._id })
        .then((res) => {
          localStorage.setItem("ss_order_id", res.data.order_id);
          window.location.href = res.data.payment_links.web;
        })
        .catch();
    }
  };
  const onFinishAddress = (values: any) => {
    console.log(values);
    setCompanyState(values.state);
    let addressData: any = {};
    addressData = {
      company_id: getUserByID?.company_id?._id,
      address: values.address,
      country: values.country,
      state: values.state,
      city: values.city,
      zipcode: values.pin_code,
      state_code: values.state_code,
      company_pancard: values.company_pancard,
      gstin_number: values.gstin_number,
    };

    console.log(addressData, "addressData");
    authSVC
      .CompanyAddress(addressData)
      .then((res: any) => {
        setShowAddress(false);
      })
      .catch((err: any) => {
        //message.error(err.message);
      });
  };

  useEffect(() => {
    console.log(getUserByID?.company_id?.package, "getUserByID Payment");
  }, [getUserByID]);

  return (
    <>
      <div className="chekout_details">
        <div className="checkout_indicator">
          <ul>
            <li className={showAddress ? "active" : ""}></li>
            <li className={showAddress ? "" : "active"}></li>
          </ul>
        </div>
        {showAddress ? (
          <div>
            <AddressPopup onFinishAddress={onFinishAddress} />
          </div>
        ) : (
          <>
            <div className="breakdown_wrapper">
              <h3 className="hr_breakdown text_left">Breakdown(s)</h3>
              {packageDetails?.map((data: any, index: any) => {
                return (
                  <>
                    <div className="plan_name">
                      {/* <h2>{data?.package_id?.package} Membership</h2>
                    <div className="duration"></div> */}
                    </div>

                    <div className="price_box">
                      <h3>Package {index + 1}</h3>
                      <ul>
                        <li>
                          <div>
                            <p>
                              {data?.packageName} Membership -{" "}
                              {data?.package_duration === "12months"
                                ? "12 months"
                                : "24 months"}
                            </p>
                          </div>
                          <div>
                            <p>₹{data?.price?.toFixed(2)}</p>
                          </div>
                        </li>
                        <li>
                          <div>
                            <p>Unit</p>
                          </div>
                          <div>
                            <p>{data?.emp_unit}</p>
                          </div>
                        </li>
                        <li>
                          <div>
                            <p>Price Per Person</p>
                          </div>
                          <div>
                            <p>₹{data?.unit_price}.00</p>
                          </div>
                        </li>

                        <li className="tax_details">
                          {companyState.toLowerCase() === "haryana" ? (
                            <>
                              <div className="line">
                                <div>
                                  <p>+ Taxes/ IGST (0)</p>
                                </div>
                                <div>
                                  <p>₹00.00</p>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="line">
                                <div>
                                  <p>+ Taxes/ IGST (18%)</p>
                                </div>
                                <div>
                                  <p>₹{data?.IGST}</p>
                                </div>
                              </div>
                            </>
                          )}

                          <div
                            className="line tax"
                            style={{ marginTop: "8px" }}
                          >
                            <div className="gray">
                              <p>CGST (9%)</p>
                            </div>
                            <div>
                              {companyState.toLowerCase() === "haryana" ? (
                                <p>₹0.00</p>
                              ) : (
                                <p>₹{data?.CGST}</p>
                              )}
                            </div>
                          </div>
                          <div className="line tax">
                            <div className="gray">
                              <p>SGST/UTGST (9%)</p>
                            </div>
                            <div>
                              {companyState.toLowerCase() === "haryana" ? (
                                <p>₹0.00</p>
                              ) : (
                                <p>₹{data?.SGST}</p>
                              )}
                            </div>
                          </div>
                        </li>
                        <li className="total_amount border">
                          <div>
                            <p>Total Amount</p>
                          </div>
                          <div>
                            <p>₹{data.totalAmount}</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </>
                );
              })}
              <div className="price_box">
                <ul>
                  <li>
                    <div>
                      <p>Subtotal</p>
                    </div>
                    <div>
                      <p>₹{subtotal.toFixed(2)}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {paymentIsOK ? (
              // Stripe Payment
              <CheckoutButton priceId={paymentId} />
            ) : (
              <button
                className="checkout_btn"
                onClick={HDFCPaymentInitiate}
                disabled={
                  getUserByID?.company_id.package.length === 0 ? true : false
                }
              >
                Continue Checkout
              </button>
            )}
          </>
        )}
      </div>
      <p className="need_help">
        Need help?{" "}
        <a
          href="https://www.soulsara.world/contact-us"
          rel="noreferrer"
          target="_blank"
        >
          Contact Us
        </a>{" "}
      </p>
    </>
  );
}

export default PaymentHDFC;
